import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Table, Input, Select, Space, Form } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import { getRequest, postRequest } from "../../axios";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import NewCitywiseAssignPurchaseDetails from "./NewCitywiseAssignPurchaseDetails";
import SelectAssignBuyer from "./SelectAssignBuyer";
import AssignedSiteEmployeeGrid from "./AssignedSiteEmployeeGrid";
import PurchaseRequisitionPdf from "./PurchaseRequisitionPdf";
import PurchaseRequisitionSteelDetails from "./PurchaseRequisitionSteelDetails";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const handleChange = (value) => {};

const { Panel } = Collapse;

const AssignPurchaseRequisitionDetails = () => {
  const [
    assignPurchaseRequisitionDetails,
    setAssignPurchaseRequisitionDetails,
  ] = useState([]);
  const [categoryTreeId, setCategoryTreeId] = useState("");
  const [no, setNo] = useState(false);
  const [material, setMaterial] = useState(null);
  const [prNum, setPrNum] = useState(null);
  const { id, categoryId } = useParams();
  const [btnLoading, setBtnLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const onChange = (key) => {};
  const [loading, setLoading] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [assignBuyer, setAssignBuyer] = useState([]);
  const [selectedAssignToBuyer, setSelectedAssignToBuyer] = useState("");

  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const pdfContainerRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const getPurchaseRequisitionDetails = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(`purchase-requisition/${id}`);
        if (apiResponse.data.data) {
          setAssignPurchaseRequisitionDetails(apiResponse.data.data);
          setPrNum(apiResponse.data.data.pr_number);
          setSelectedAssignToBuyer(apiResponse?.data?.data?.pr_assign_to_buyer);
          const categoryTreeId = apiResponse.data.data.category_tree;
          setCategoryTreeId(categoryTreeId);
          setMaterial(apiResponse.data.data.pr_type);
        } else {
          ErrorNotificationMsg(t("error_in_purchase_requisition"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getPurchaseRequisitionDetails();
    getCurrency();
  }, []);

  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };

  const AssignRenderTables = () => {
    if (!assignPurchaseRequisitionDetails.purchase_requisition_details)
      return null;

    const groupedDetails = {};
    assignPurchaseRequisitionDetails.purchase_requisition_details.forEach(
      (detail) => {
        const subCategory = detail.sub_category;
        if (!groupedDetails[subCategory]) {
          groupedDetails[subCategory] = { sites: {}, details: [] };
        }
        groupedDetails[subCategory].details.push(detail);
        detail.site_wise.forEach((site) => {
          groupedDetails[subCategory].sites[site.site_name] = true;
        });
      }
    );

    return Object.entries(groupedDetails).map(
      ([subCategory, { sites, details }], index) => {
        const siteNames = Object.keys(sites);
        const site_wise = Object.keys(sites);

        let customSubcategory = "";

        if (subCategory === "SPECIAL CEMENT") {
          customSubcategory = "Special Cement";
        } else {
          customSubcategory = subCategory;
        }
        const data = [];

        details.map((detail, index) =>
          data.push({
            ...detail,
            srNo: index,
            key: detail.pr_details_id?.toString(),
            totalQuantity: `${detail.total_quantity} ${detail.unit_of_measurement_name}`,
            remark: detail.remark,
          })
        );

        const siteNameColumns = siteNames.map((site, index) => ({
          title: site,
          dataIndex: index,
          key: index,
          width: 110,
        }));

        const siteWiseColumns = site_wise.map((site, siteIndex) => ({
          title: "Site Input",
          dataIndex: `siteInput_${siteIndex}`,
          key: `siteInput_${siteIndex}`,
          width: 110,
          align: "right",
          render: (text, record) => {
            const matchingSite = record.site_wise.find(
              (s) => s.site_name === site
            );
            console.log("matchingSite", matchingSite);
            if (matchingSite) {
              return (
                <div
                  className="lblvalue"
                  style={{ marginLeft: "5px", textAlign: "end" }}
                >
                  {matchingSite?.quantity}
                </div>
              );
            }
            return null;
          },
        }));

        const columns1 = [
          {
            title: `${index + 1}`,
            dataIndex: "srNo",
            key: "1",
            width: 50,
            render: (text, record, ind) => `${index + 1}.${ind + 1}`,
          },
          {
            title: `${customSubcategory}`,
            dataIndex: `${subCategory}`,
            key: `${subCategory}`,
            width: "130px",
            render: (text, record) => {
              console.log("wrt", record);
              return (
                <>
                  {record.site_wise.map((site, siteIndex) => (
                    <Input readOnly key={siteIndex} value={site.quantity} />
                  ))}
                </>
              );
            },
          },
          ...siteNameColumns,
          {
            title: "Total Qty.",
            dataIndex: "TOTAL",
            key: "8",
            width: 100,
            align: "right",
          },
          {
            title: "UoM.",
            dataIndex: "UOM",
            key: "7",
            width: 80,
          },

          {
            title: "Total Qty. in Kg",
            dataIndex: "Total Kilogram",
            key: "8",
            width: 130,
            align: "right",
          },
          {
            title: "Est. Amount",
            dataIndex: "Total Kilogram",
            key: "9",
            width: 150,
            align: "right",
          },
          {
            title: "Remarks",
            dataIndex: "Remark",
            key: "3",
          },
        ];

        const thead = <Table columns={columns1} />;

        return (
          <Collapse
            key={index.toString()}
            defaultActiveKey={[index.toString()]}
            className="scroll3"
          >
            <Panel key={index.toString()} header={thead}>
              <Table
                columns={[
                  {
                    title: `${index + 1}`,
                    dataIndex: "srNo",
                    key: "1",
                    width: 40,
                    render: (text, record, ind) => `${index + 1}.${ind + 1}`,
                  },
                  {
                    title: "Type Name",
                    dataIndex: "material_type_name_by_company",
                    key: "material_type_name_by_company",
                    width: "130px",
                  },

                  ...siteWiseColumns,
                  {
                    title: "Total Quantity",
                    dataIndex: "totalQuantity",
                    key: "totalQuantity",
                    width: 100,
                    align: "right",
                    render: (text, record) => (
                      <div
                        className="lblvalue"
                        style={{
                          marginLeft: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        {record.total_quantity?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}
                      </div>
                    ),
                  },
                  {
                    title: "UOM",
                    dataIndex: "unit_of_measurement",
                    key: "unit_of_measurement",
                    width: 80,
                    render: (text, record) => {
                      console.log("textcxz", text, "record", record);
                      return (
                        <div className="lblvalue" style={{ marginLeft: "0px" }}>
                          {record.unit_of_measurement_name === "Cubic Meter"
                            ? "Cu. Mtr."
                            : record.unit_of_measurement_name}
                        </div>
                      );
                    },
                  },
                  {
                    title: "Qty In Kg",
                    dataIndex: "total_quantity_by_kg",
                    key: "total_quantity_by_kg",
                    width: 130,
                    align: "right",
                    render: (text, record) => {
                      return (
                        <div
                          className="lblvalue"
                          style={{
                            marginLeft: "5px",
                            justifyContent: "flex-end",
                          }}
                        >
                          {record.total_quantity_by_kg?.toLocaleString(
                            "en-IN",
                            {
                              maximumFractionDigits: 0,
                            }
                          )}
                        </div>
                      );
                    },
                  },
                  {
                    title: "Est. Amount",
                    dataIndex: "total_quantity",
                    key: "total_quantity",
                    width: 150,
                    align: "right",
                    render: (text, record) => {
                      let amount = 1;
                      if (record.total_quantity_by_kg === 0) {
                        amount =
                          record.estimated_material_unit_price *
                          record.total_quantity;
                      } else {
                        amount =
                          record.estimated_material_unit_price *
                          record.total_quantity_by_kg;
                      }
                      return (
                        <div
                          className="lblvalue"
                          style={{
                            marginLeft: "5px",
                            justifyContent: "flex-end",
                          }}
                        >
                          ₹{" "}
                          {amount?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })}
                        </div>
                      );
                    },
                  },
                  {
                    title: "Remark",
                    dataIndex: "remark",
                    key: "remark",
                    render: (text, record) => {
                      return <span>{record.remark}</span>;
                    },
                  },
                ]}
                dataSource={data}
                pagination={false}
                scroll={{ x: "auto" }}
              />
            </Panel>
          </Collapse>
        );
      }
    );
  };

  useEffect(() => {
    const getAssignBuyer = async () => {
      setLoading(true);
      try {
        const response = await getRequest(
          `purchase-requisition/assign-to-buyer`
        );
        setAssignBuyer(response.data.results.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
    getAssignBuyer();
  }, [categoryId, no]);

  const handleFloatRFQ = async (selectedRowIds = []) => {
    if (selectedRowIds.length === 0) {
      ErrorNotificationMsg("Please select minimum one PR");
      return;
    }
    console.log(
      "selectedRowIds",
      selectedRowIds,
      "assignPurchaseRequisitionDetails",
      assignPurchaseRequisitionDetails
    );

    if (
      selectedRowIds.some(
        (id) =>
          assignPurchaseRequisitionDetails?.id === Number(id) &&
          assignPurchaseRequisitionDetails?.pr_assign_to_buyer === null
      )
    ) {
      ErrorNotificationMsg("Please assign to buyer");
      return;
    }

    try {
      setBtnLoading(true);
      let apiResponse = await postRequest(`float-rfq/`, {
        company: CompanyID,
        category_tree: categoryId,
        purchase_requisition_master: selectedRowIds,
      });

      const responseId = apiResponse.data.data.id;
      navigate(`/request-for-quotation/add-rfq/${responseId}`, {
        state: {
          categoryId: categoryId,
        },
      });
    } catch (error) {
      console.error("Error:", error);
      setBtnLoading(false);
    } finally {
      setBtnLoading(false);
    }
  };
  
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Assign Purchase Requisition (PR) - Details</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={`/purchase-requisition-assign/${categoryTreeId}`}>
                  Assign Purchase Requisition
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                Assign Purchase Requisition Details
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className="btnscol">
            <Space>
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="button"
                label="Float RFQ"
                onClick={() => handleFloatRFQ([id])}
                loading={btnLoading}
              />
              <PurchaseRequisitionPdf
                pdfContainerRef={pdfContainerRef}
                prNumber={prNum}
                buttonRef={buttonRef}
                setIsDownloading={setLoading}
                downloading={loading}
              />
              <ButtonField
                className="CancelGradiantBtn"
                type="primary"
                htmlType="Back"
                label="Back"
                onClick={() =>
                  navigate(`/purchase-requisition-assign/${categoryTreeId}`)
                }
              />
            </Space>
          </div>
        </div>
      </div>
      <div className="stepscontentwrap">
        <div className="stepsContent">
      <section className="grid-sec mt-5" ref={pdfContainerRef}>
      <SubscriptionNotification />
        <div className="PR-body" style={{padding:'0'}}>
          <div className="filterrow">
            <div className="filtercol">
              <Space wrap>
                <div className="lblwrp">
                  <label>PR Creator</label>
                  <h6>{assignPurchaseRequisitionDetails.pr_creator}</h6>
                </div>
                <div className="lblwrp">
                  <label>PR Number</label>
                  <h6>{assignPurchaseRequisitionDetails.pr_number}</h6>
                </div>
                <div className="lblwrp">
                  <label>PR Approval Date</label>
                  <h6>
                    {assignPurchaseRequisitionDetails.pr_approval_date
                      ? assignPurchaseRequisitionDetails.pr_approval_date
                      : "Pending"}
                  </h6>
                </div>
                <div className="lblwrp">
                    <label>Category</label>
                    <h6>{assignPurchaseRequisitionDetails.category_tree_name}</h6>
                  </div>
                <div className="lblwrp assignb">
                  <Form.Item name="assign_to_buyer" label="Assign PR To Buyer">
                    <SelectAssignBuyer
                      assignToBuyer={
                        assignPurchaseRequisitionDetails.pr_assign_to_buyer
                      }
                      assignBuyer={assignBuyer}
                      assignPurchaseRequisitionDetails={
                        assignPurchaseRequisitionDetails
                      }
                    />
                  </Form.Item>
                </div>
              </Space>
            </div>
          </div>
          <Collapse defaultActiveKey={["0"]} className="scroll3">
            {assignPurchaseRequisitionDetails.category_tree_name
              ?.toLowerCase()
              .includes("steel") ? (
              <PurchaseRequisitionSteelDetails
                prData={assignPurchaseRequisitionDetails}
              />
            ) : material === "City Wise" ? (
              <NewCitywiseAssignPurchaseDetails PRid={id} />
            ) : (
              AssignRenderTables()
            )}
          </Collapse>
          <AssignedSiteEmployeeGrid prId={id} ref={pdfContainerRef} />
        </div>
       
      </section>
      </div>
       <div style={{display:"flex", justifyContent: "flex-end", padding: "10px 20px" }}>
           <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="Back"
              label="Back"
              onClick={() =>
                navigate(`/purchase-requisition-assign/${categoryTreeId}`)
              }
            />
            <PurchaseRequisitionPdf
              pdfContainerRef={pdfContainerRef}
              prNumber={prNum}
              buttonRef={buttonRef}
              setIsDownloading={setLoading}
              downloading={loading}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label="Float RFQ"
              onClick={() => handleFloatRFQ([id])}
              loading={btnLoading}
            />

        
      
        </div>
      </div>
    </>
  );
};
export default AssignPurchaseRequisitionDetails;
